import { Navigate } from "react-router";
import { useGetIdentity } from "ra-core";

import { PageSpinner } from "./comuns";
import { PainelSeguros } from "./PainelSeguros";
import { useCorretoraVinculada } from "./portalAzos";

/**
 * Dashboard de Seguros. Lê a carteira: o super admin vê a rede inteira e quem
 * tem corretora vinculada (Conexões › Azos, 298) vê a dela, pela RLS da 206 —
 * a conta de demonstração entra por aqui (313). Para os demais, Seguros é a
 * Cotação, e é para lá que a rota leva.
 */
export const SegurosHome = () => {
  const { identity, isPending } = useGetIdentity();
  const superAdmin = !!identity?.is_super_admin;
  const corretora = useCorretoraVinculada(!isPending && !!identity && !superAdmin);
  if (isPending || !identity) return null;
  if (superAdmin) return <PainelSeguros />;
  if (corretora.isPending) return <PageSpinner />;
  if (!corretora.data) return <Navigate to="/seguros/cotacao" replace />;
  return <PainelSeguros />;
};
